import moment from 'moment';
import { Capacitor } from '@capacitor/core';
import { getSignatureHash } from '../../native/SignaturePlugin';

const BASE_URL = process.env.REACT_APP_API_ENDPOINT || '';
const VALIDATE_PATH = '/auth/validate';

/**
 * Reads APK cert hash from native PackageManager and validates with server.
 * Returns true if this APK is on the server whitelist, false otherwise.
 */
export const validateAppTokenApi = async (): Promise<boolean> => {
  if (Capacitor.getPlatform() !== 'android') {
    return true;
  }

  const requestUrl = `${BASE_URL}${VALIDATE_PATH}`;
  const certHash = await getSignatureHash();
  const payload = {
    certHash,
    nonce: crypto.randomUUID().replace(/-/g, ''),
    timestamp: String(moment.utc().valueOf()),
  };

  let response: Response;
  try {
    response = await fetch(requestUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  } catch {
    return false;
  }

  const rawBody = await response.text();

  if (!response.ok) return false;

  try {
    const result = JSON.parse(rawBody);
    return result === true || result?.valid === true;
  } catch {
    return false;
  }
};
